import {
  Box,
  Button,
  ClickAwayListener,
  colors,
  InputAdornment,
  TextField,
  useTheme,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../global/theme/tokens';
import { func } from 'prop-types';
import { API_POST, DBRequest } from '../../../api/api';

const TypeUrl = ({
  field,
  dataCollection,
  errors,
  updateValidationOnChange,
  startDataCollection,
  size,
  onChange,
  hidden = false,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { t } = useTranslation();

  const inputRef = useRef(null);
  const [value, setValue] = useState(dataCollection[field.key] || '');
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (field.focusOnMount) {
      inputRef.current?.focus();
    }
  }, [field.focusOnMount]);

  function handleFocus() {
    setFocused(true);
  }

  function handleTextChange(e) {
    const newValue = e.target.value;
    setValue(newValue);
    updateValidationOnChange([field.key], newValue);
  }

  function handleBlur(e) {
    if (e.target.value === '') return;
    // to lower case
    const newUrl = e.target.value.toLowerCase();

    // check if https:// is there

    const hasHttps = newUrl.indexOf('https://') !== -1;
    const hasHttp = newUrl.indexOf('http://') !== -1;

    const realUrl = hasHttps || hasHttp ? newUrl : `https://${newUrl}`;
    setValue(realUrl);
    updateValidationOnChange([field.key], realUrl);

    onChange?.(realUrl);
    setFocused(false);
  }
  function handleClick(e) {
    e.preventDefault();
    // When the scraping functionality is implemented at backend, uncomment the following lines

    //  DBRequest({
    //       config,
    //       path: 'scrape-url',
    //       method: API_POST(data),
    //       onResponse: handleScrapedData,
    //     });
    console.log('Scraping URL:', value);
  }

  function handleScrapedData(res) {
    updateValidationOnChange([field.key], res.data, true);
  }

  return (
    <>
      {!hidden && (
        <Box className="h-full flex w-full gap-2">
          <TextField
            label={field.label}
            value={value}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onChange={handleTextChange}
            multiline={Boolean(field.multiline)}
            size={size}
            sx={{
              width: '100%',
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">{field.unit}</InputAdornment>
              ),
            }}
          />

          {field.allowScraping && (
            <Button
              sx={{
                bgcolor: colors.bgInput,
                ':hover': { bgcolor: colors.selected },
              }}
              variant="contained"
              onClick={handleClick}
            >
              Scrape URL
            </Button>
          )}
        </Box>
      )}
    </>
  );
};

export default TypeUrl;
